import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import blockClientNavigation from '~/scopes/product-core/middleware/blockClientNavigation/blockClientNavigation'
import masterPP from '~/scopes/product-core/middleware/masterPP/masterPP'
import redirectInvalidUUID from '~/scopes/product-core/middleware/redirectInvalidUUID/redirectInvalidUUID'
import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

export default (): RouteRecordRaw[] => {
  const { FF_MODULAR_PDP_ENABLED_BY_COUNTRY } = useRuntimeConfig().public
  const { market } = useMarketplace()

  const isModularPdpEnabled = FF_MODULAR_PDP_ENABLED_BY_COUNTRY.includes(
    market.countryCode,
  )

  return [
    {
      component: () =>
        import('~/scopes/product-core/pages/ProductProxy/ProductProxy.vue'),
      name: PRODUCT_ROUTES.VARIANT_PRODUCT_PAGE,
      path: 'p/:slugV2/:uuid',
      meta: {
        middleware: isModularPdpEnabled
          ? [redirectInvalidUUID, blockClientNavigation]
          : [redirectInvalidUUID],
        owners: ['bot-squad-product-page-front'],
        cache: 'public, max-age=90000, stale-while-revalidate=90000',
      },
    },
    {
      component: () =>
        import('~/scopes/product-core/pages/ProductProxy/ProductProxy.vue'),
      name: PRODUCT_ROUTES.MASTER_PRODUCT_PAGE,
      path: 'p/:slug',
      meta: {
        middleware: isModularPdpEnabled
          ? [masterPP, blockClientNavigation]
          : [masterPP],
        owners: ['bot-squad-product-page-front'],
        cache: 'public, max-age=90000, stale-while-revalidate=90000',
      },
    },
    // Webviews
    {
      component: () =>
        import('~/scopes/product-core/components/presentationals/CustomizationFunnel/components/VisibleByVerizonDrawer/components/VisibleByVerizonDrawerBody/VisibleByVerizonDrawerBody.vue'),
      name: PRODUCT_ROUTES.WEBVIEWS_VISIBLE_BY_VERIZON_DRAWER,
      path: 'p/drawers/visible-by-verizon',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
    {
      component: () =>
        import('~/scopes/product-core/components/presentationals/CustomizationFunnel/components/ProcessorModal/components/MacbookProcessorModal/components/MacbookProcessorModalBody/MacbookProcessorModalBody.vue'),
      name: PRODUCT_ROUTES.WEBVIEWS_MACBOOK_PROCESSOR_DRAWER,
      path: 'p/drawers/processor/macbook',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
    {
      component: () =>
        import('~/scopes/product-core/components/presentationals/CustomizationFunnel/components/ProcessorModal/components/LaptopProcessorModal/components/LaptopProcessorModalBody/LaptopProcessorModalBody.vue'),
      name: PRODUCT_ROUTES.WEBVIEWS_LAPTOP_PROCESSOR_DRAWER,
      path: 'p/drawers/processor/laptop',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
    {
      component: () =>
        import('~/scopes/product-core/components/presentationals/ReassuranceItems/components/ItemObsoleteComputer/components/ObsoleteComputerModalBody/ObsoleteComputerModalBody.vue'),
      name: PRODUCT_ROUTES.WEBVIEWS_OBSOLETE_DRAWER,
      path: 'p/drawers/obsolete',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },

    /**
     * @deprecated Use WEBVIEWS_MACBOOK_PROCESSOR_DRAWER instead
     */
    {
      component: () =>
        import('~/scopes/product-core/components/presentationals/CustomizationFunnel/components/ProcessorModal/components/MacbookProcessorModal/components/MacbookProcessorModalBody/MacbookProcessorModalBody.vue'),
      name: PRODUCT_ROUTES.WEBVIEWS_PROCESSOR_DRAWER,
      path: 'p/drawers/processor',
      meta: {
        layout: false,
        owners: ['bot-squad-product-page-front'],
      },
    },
  ]
}
